import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Book, Heart, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <footer className="bg-gray-900 text-white py-14 px-4" data-testid="footer">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Book className="w-5 h-5 text-rose-300" />
              <span className="text-lg font-bold tracking-tight">Life Echo</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">{t('footer.tagline')}</p>
          </div>
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-gray-300 mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#how-it-works" className="hover:text-rose-300 transition-colors">{t('footer.howItWorks')}</a></li>
              <li><a href="#pricing" className="hover:text-rose-300 transition-colors">{t('footer.pricing')}</a></li>
              <li><a href="#faq" className="hover:text-rose-300 transition-colors">{t('footer.faq')}</a></li>
              <li><button onClick={() => navigate('/community')} className="hover:text-rose-300 transition-colors">{t('footer.community')}</button></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-gray-300 mb-4">{t('footer.getInTouch')}</h4>
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-rose-300" /><span>hello@lifeecho.com</span></div>
              <div className="flex items-center gap-2"><Heart className="w-4 h-4 text-rose-300" /><span>{t('footer.madeWithLove')}</span></div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center text-xs text-gray-500">
          <p>&copy; {new Date().getFullYear()} Life Echo. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
